import { sleep } from '../tools/sleep';
import uniqWith from 'lodash/uniqWith';

function packageUniq(array) {
	return uniqWith(array, (x, y) => x.name === y.name && x.version === y.version);
}

export async function startVirtualPackageDownloader(packages) {
	for (let i = 0; i < packages.length; i++) {
		await sleep(200);
		window.nativeOnAppOfflineAppSyncProgress(i + 1, packages.length, 'null');
	}
	localStorage.virtualPackageDownloader = JSON.stringify(packages);
	localStorage.virtualPackageDownloaderLength = packages.length;
}

export function getVirtualPackageDownloader(offlineAppWithVersionProviderInit) {
	return packageUniq(
		JSON.parse(localStorage.virtualPackageDownloader ? localStorage.virtualPackageDownloader : '[]').concat(
			offlineAppWithVersionProviderInit
		)
	);
}
